// Module
var code = "<div layout=\"row\" layout-wrap class=\"emojiContainer\"> <md-button class=\"tool-button\" ng-repeat=\"emoji in ctrl.emojis\" ng-click=\"ctrl.select(emoji)\" aria-label=\"{{::emoji.name}}\"> <div layout=\"row\" layout-align=\"center center\"> <div class=\"emojiDisplay\" flex=\"none\">{{ emoji.value }}</div> </div> </md-button> </div> ";
// Exports
module.exports = code;